import React from 'react'
import {Link} from "react-router-dom";
import {MainLayout} from "../../layouts/main";

const NotFound = () => {


    return (
        <MainLayout className="d-flex align-items-center justify-content-between flex-column">
                <div className={`container-custom text-center`}>
                    <h1 className={"mb-4"}>Ошибка 404</h1>
                    <h2  className={"mb-4"}>Страница не найдена</h2>
                    <div className={`d-flex align-items-center justify-content-center`}>
                        <Link to={'/'} className={"btn btn-red-filled"}>На главную</Link>
                    </div>
                </div>
        </MainLayout>
    )
}

export default NotFound;